import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex-item-scroll text-left" }
const _hoisted_2 = { class: "flex-container-row flex-wrap gap5" }
const _hoisted_3 = { class: "k-text-large" }
const _hoisted_4 = { class: "k-text-large" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { style: {"font-weight":"bold"} }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "flex-container-row align-center gap10" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createBlock(_component_loader_guard, {
    hasLoaded: _ctx.hasLoaded,
    class: "flex-item-scroll"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_card_header, { class: "k-hstack section" }, {
              default: _withCtx(() => [
                _createVNode(_component_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('Software')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_card_body, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_header, { class: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.localize('InstalledVersion')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card_body, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.installedVersion || 'N/A'), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.availableVersion)
                    ? (_openBlock(), _createBlock(_component_card, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_header, { class: "label" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.localize('AvailableVersion')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_card_body, null, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.availableVersion), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_card_header, { class: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.localize('Status')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_card_body, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "flex-container-row align-center gap10",
                            style: _normalizeStyle(_ctx.statusStyle)
                          }, [
                            _createElementVNode("img", {
                              src: _ctx.statusIcon,
                              class: "icon-bullet"
                            }, null, 8, _hoisted_5),
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.statusTitle), 1)
                          ], 4),
                          _createElementVNode("div", {
                            style: {"padding-top":"10px"},
                            innerHTML: _ctx.statusDescription
                          }, null, 8, _hoisted_7)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.showUpdate)
          ? (_openBlock(), _createBlock(_component_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_card_header, { class: "k-hstack section" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localize('Update')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card_body, null, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_8, [
                      _createElementVNode("img", {
                        src: _ctx.iconDownload,
                        class: "icon-bullet"
                      }, null, 8, _hoisted_9),
                      _createElementVNode("a", {
                        href: _ctx.downloadUrl,
                        target: "_blank",
                        rel: "noopener",
                        class: "blue-textlink"
                      }, _toDisplayString(_ctx.localize('HowToDownloadAndUpdate')), 9, _hoisted_10)
                    ], 512), [
                      [_vShow, _ctx.downloadUrl]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["hasLoaded"]))
}